// 是否可选已下架状态
export const getDisabled = (item, isCheckDelete) => {
  if (isCheckDelete) {
    return false
  }
  return item.status === 2
}
// 可选已下架时，展示已下架标签
export const getShowSpan = (item, isCheckDelete) => {
  if (!isCheckDelete) {
    return false
  }
  return item.status === 2
}
